export interface SpinnerStyles {
  style?: React.CSSProperties;
}

export const styles: SpinnerStyles = {
  style: { width: '1em', height: '1em' },
};
